import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import "vue-loading-overlay/dist/vue-loading.css";
import { request } from "@/js/http/http_request";
import { scrollTo } from "@/js/animation.js";
import { getOrderConfirmationReference, calculateOrderAmountsLocal, getUnitPriceCurrencyForItem, showShippingPriceMinusDefault } from "@/js/order/order.js";
import { getClientAppData, isHolding, hasRole } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { getFullNameUserHtml, getFullNameUser } from "@/js/user/user.js";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { isSameAddress } from "@/js/address";
import { isArrowKey, filterIntegerKey } from "@/js/events/keycodes.js";
import { orderStatus, orderStatusAdjusting, expeditionMethods, listTerms, listTermsCustomer, casingWines, listWineTypes, orderAdjustmentsTypes, paymentState as _paymentState, TASTING_PHOTOS } from "@/js/lists.ts";
import { wineNaming } from "@/js/wine/wine.js";
import Error from "@/views/error/error.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import adressComponent from "@/components/address/Address.vue";
import PaymentBadgeMulti from "@/components/payment/PaymentBadgeMulti.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import WholesalersData from "@/components/payment/WholesalersData.vue";
import TastingPhotoUploadFormModal from "@/components/tasting-photos/TastingPhotoUploadFormModal.vue";
import WineDiscountTooltip from "@/components/products/WineDiscountTooltip.vue";
import StorageTermsReference from "@/components/common/StorageTermsReference.vue";
export default {
  name: "ConsultantOrderSummary",
  data: function data() {
    return {
      clientAppData: null,
      isCollapsed: false,
      sameAddress: true,
      bufferedAddresses: {
        billingAddress: null,
        deliveryAddress: null,
        isSameAddress: null
      },
      isEditingAddresses: false,
      updateAddressesToken: null,
      deliveryAddressFaultedMessage: null,
      orderCtaStyles: {},
      isProcessingPayment: false,
      order: {
        id_order: null,
        buyer_term: null,
        items: [],
        id_user: null,
        amount_ex_vat: null,
        total_amount: null,
        status: null,
        expedition_method: 0,
        expedition_methods: {},
        delivery_address: null,
        delivery_instructions: null,
        billing_address: null,
        id_carrier: null,
        amount_shipping: null,
        due_date: null,
        cancellation_date: null,
        deleted: false,
        user: null,
        stockTransferIsAskedByUser: false,
        isStockTransfer: false
      },
      imagesBroken: [],
      listCountries: [],
      listStates: [],
      lastExpeditionMethod: null,
      expedition_methods: [],
      expeditionMethods: expeditionMethods,
      checkboxCGV: false,
      checkboxLawCompliance: false,
      checkboxTastingPhoto: [],
      errorLabels: {
        shipping: {},
        terms: "",
        cgv: "",
        tastingPhoto: "",
        quantity_orders: "",
        adjustment: ""
      },
      errorMessages: {
        mandatory: "This field is required",
        cgv: {
          required: "You must accept the terms of sales, and certify you are complying with the law"
        },
        tastingPhoto: {
          required: "You must notify the customer to take a photo of some bottles at time of tasting"
        },
        order: {
          quantity: "You don't reach the minimum per order"
        },
        shippingType: {
          required: "You must select a shipping type"
        }
      },
      adjustmentToken: null,
      adjustments: [],
      orderAdjustmentsTypes: orderAdjustmentsTypes,
      dialogAdjustment: {
        visible: false,
        message: null,
        type: null,
        historicVisible: false
      },
      updateDeliveryInstructionsToken: null,
      editingDeliveryInstructions: false,
      newDeliveryInstructions: "",
      isDeliveryInstructionsAsDefaultForUserAdress: false,
      fetchingOrder: {
        isPending: false,
        cancellationToken: null
      },
      fetchingItem: {},
      fetchingOrderShipping: {
        isPending: false,
        cancellationToken: null
      },
      returningToAdjusting: {
        isPending: false,
        cancellationToken: null
      },
      addingWine: {
        isPending: false,
        cancellationToken: null,
        itemChosen: null,
        searchingWines: {
          isPending: false,
          cancellationToken: null,
          searchValue: "",
          results: []
        }
      },
      changingQuantityOrder: {},
      deletingItem: {},
      idProductsUpdating: [],
      confirmingAdjustments: {
        isPending: false,
        cancellationToken: null
      },
      confirmingForCustomer: {
        isPending: false,
        cancellationToken: null
      },
      isDocumentsFetched: false,
      documentDialog: false,
      fetchingDocuments: {
        isPending: false,
        cancellationToken: null
      },
      calculatingOrderAmounts: {
        isPending: false,
        cancellationToken: null
      },
      mustRefreshLogisticDetails: false,
      fetchingLogisticDetails: {
        isPending: false,
        cancellationToken: null
      },
      updatingExpeditionMethod: {
        isPending: false,
        cancellationToken: null
      },
      resettingLogisticDetails: {
        isPending: false,
        cancellationToken: null
      },
      proposingAdjustment: {
        isPending: false,
        cancellationToken: null
      },
      tastingPhotos: {
        canManage: true,
        required: {
          isSearchPending: false,
          items: []
        },
        upload: {
          isComponentCreated: false,
          tastingPhotoRequiredId: null
        }
      },
      fetchingCompleteWines: {
        isPending: false,
        cancellationToken: null
      },
      managedExceptions: {
        warning: {
          order_pricing_credit_notes_amount_invalid: "The credits applied amount exceeds the products amount."
        }
      },
      casingWines: casingWines,
      listTerms: listTerms,
      listTermsCustomer: listTermsCustomer,
      orderStatus: orderStatus,
      orderStatusAdjusting: orderStatusAdjusting,
      wineNaming: wineNaming,
      ERROR_DATA: ERROR_DATA,
      TASTING_PHOTOS: TASTING_PHOTOS
    };
  },
  components: {
    "wine-naming": WineNaming,
    PaymentBadgeMulti: PaymentBadgeMulti,
    adress: adressComponent,
    confirm: confirmationComponent,
    WholesalersData: WholesalersData,
    ErrorModal: ErrorModal,
    Error: Error,
    TastingPhotoUploadFormModal: TastingPhotoUploadFormModal,
    WineDiscountTooltip: WineDiscountTooltip,
    StorageTermsReference: StorageTermsReference
  },
  props: ["baseModel", "loggedUserData"],
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this2$baseModel;
      var currentTerms, _this;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if ((_this2$baseModel = _this2.baseModel) !== null && _this2$baseModel !== void 0 && _this2$baseModel.id_order) {
              _context.next = 3;
              break;
            }
            _this2.$router.push({
              name: "userHome"
            });
            return _context.abrupt("return");
          case 3:
            _this2.clientAppData = getClientAppData(_this2);
            _this2.$EventBus.$emit("loading", true);
            _this2.order = _objectSpread(_objectSpread({}, _this2.order), _this2.baseModel);
            _this2.computeCasings();
            _this2.isDeliveryInstructionsAsDefaultForUserAdress = _this2.isOrderDeliveryInstructionsDefaultUser();
            currentTerms = listTerms.find(function (x) {
              return x.id === _this2.order.buyer_term;
            });
            if (!listTermsCustomer.some(function (x) {
              return x.id === currentTerms.id;
            })) {
              _this2.listTermsCustomer = [].concat(_toConsumableArray(_this2.listTermsCustomer), [currentTerms]);
            }
            if (_this2.orderStatusAdjusting.includes(_this2.order.status)) {
              _this2.fetchAdjustments();
            }
            _this2.sameAddress = isSameAddress(_this2.order.delivery_address, _this2.order.billing_address);
            if (!_this2.isShippingEditable) {
              _context.next = 15;
              break;
            }
            _context.next = 15;
            return _this2.fetchOrderLogistic();
          case 15:
            _this = _this2;
            request("/v1/countries?implantedMarket=true", "post", _this.clientAppData, false, "api").then(function (response) {
              _this.listCountries = _toConsumableArray(response.data.countries);
              _this.listStates = _toConsumableArray(response.data.states);
            }).catch(function () {
              _this.$toasted.show("Unable to load countries.", {
                type: "error"
              });
            });
            _this2.refetchDocs();
            _this2.getRequiredTastingPhotos();
            if (_this2.isOrderEditable) _this2.fetchCompleteWinesForDiscounts();
            _this2.$EventBus.$emit("loading", false);
            if (_this2.order.delivery_instructions) {
              _this2.inputDeliveryInstructions = _this2.order.delivery_instructions;
            }
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    isAnyMainActionInProgress: function isAnyMainActionInProgress() {
      return this.fetchingLogisticDetails.isPending || this.updatingExpeditionMethod.isPending || this.calculatingOrderAmounts.isPending || this.confirmingAdjustments.isPending || this.confirmingForCustomer.isPending || this.addingWine.isPending;
    },
    isStoredInbound: function isStoredInbound() {
      return this.order.is_destination_inbound || this.order.isStockTransfer;
    },
    isGreatExport: function isGreatExport() {
      var _this$order;
      return !((_this$order = this.order) !== null && _this$order !== void 0 && (_this$order = _this$order.delivery_address) !== null && _this$order !== void 0 && (_this$order = _this$order.country) !== null && _this$order !== void 0 && _this$order.european_union_member);
    },
    isOrderForHoreca: function isOrderForHoreca() {
      return this.order.user.user_group === "HORECA" || this.order.user.user_group === "WHOLESALER" || this.order.user.isHolding;
    },
    isOrderForHorecaUs: function isOrderForHorecaUs() {
      return this.isOrderForHoreca && this.order.delivery_address.country.iso_2 === "US";
    },
    isOrderForIndividualUs: function isOrderForIndividualUs() {
      var _this$order2, _this$order3;
      return ((_this$order2 = this.order) === null || _this$order2 === void 0 || (_this$order2 = _this$order2.user) === null || _this$order2 === void 0 ? void 0 : _this$order2.user_group) === "USER" && ((_this$order3 = this.order) === null || _this$order3 === void 0 || (_this$order3 = _this$order3.delivery_address) === null || _this$order3 === void 0 ? void 0 : _this$order3.country.iso_code) === "USA";
    },
    isOrderEditable: function isOrderEditable() {
      return (this.isAdjusting || this.order.status === this.orderStatus.find(function (x) {
        return x.id === "VALIDATED";
      }).status && hasRole(process.env.VUE_APP_ROLES_CONSULTANT_MANAGE_VALIDATED_ORDERS)) && !this.isPaymentSucceeded && !this.isPaymentProcessing && !this.isAnyTypeInvoiced;
    },
    isDocumentsConsultable: function isDocumentsConsultable() {
      return this.order.status !== this.orderStatus.find(function (x) {
        return x.id === "ADJUSTING";
      }).status;
    },
    documentCount: function documentCount() {
      var _this$documents;
      return (_this$documents = this.documents) === null || _this$documents === void 0 ? void 0 : _this$documents.reduce(function (acc, x) {
        return acc + x.children.length;
      }, 0);
    },
    hasBeenValidated: function hasBeenValidated() {
      return !orderStatus.filter(function (x) {
        return ["AWAITING_CUSTOMER_VALIDATION", "AWAITING_VALIDATION", "ADJUSTING"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.order.status);
    },
    isPaymentSucceeded: function isPaymentSucceeded() {
      var _this$order$payments;
      if ((_this$order$payments = this.order.payments) !== null && _this$order$payments !== void 0 && _this$order$payments.length) {
        return this.order.payments.some(function (x) {
          return [_paymentState.SUCCEEDED].includes(x.state);
        });
      }
      return [_paymentState.SUCCEEDED].includes(this.order.payment_state);
    },
    isPaymentProcessing: function isPaymentProcessing() {
      var _this$order$payments2;
      if ((_this$order$payments2 = this.order.payments) !== null && _this$order$payments2 !== void 0 && _this$order$payments2.length) {
        return this.order.payments.some(function (x) {
          return [_paymentState.PROCESSING].includes(x.state);
        });
      }
      return [_paymentState.PROCESSING].includes(this.order.payment_state);
    },
    isShipped: function isShipped() {
      return orderStatus.filter(function (x) {
        return ["DELIVERY", "CUSTOMS_CLEARANCE", "INBOUND", "DELIVERED"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.order.status);
    },
    isCancelled: function isCancelled() {
      return this.order.status == orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status;
    },
    isDelivered: function isDelivered() {
      return orderStatus.find(function (x) {
        return x.id === "DELIVERED";
      }).status === this.order.status;
    },
    isInvoiceConsultable: function isInvoiceConsultable() {
      return this.order.isInvoiced && (this.isShipped || this.isCancelled);
    },
    isImporterInvoiceConsultable: function isImporterInvoiceConsultable() {
      return this.order.isImporterInvoiced && (this.isShipped || this.isCancelled);
    },
    isAnyTypeInvoiced: function isAnyTypeInvoiced() {
      return this.order.isAnyTypeInvoiced;
    },
    isConcernedByVat: function isConcernedByVat() {
      var _this$order4;
      return ((_this$order4 = this.order) === null || _this$order4 === void 0 ? void 0 : _this$order4.amount_vat) > 0;
    },
    hasMissingLogisticCost: function hasMissingLogisticCost() {
      return false;
    },
    isShippingEditable: function isShippingEditable() {
      return this.isOrderAwaitingCustomerValidation || this.isAdjusting;
    },
    isOrderAwaitingCustomerValidation: function isOrderAwaitingCustomerValidation() {
      return this.order.status == this.orderStatus.find(function (os) {
        return os.id === "AWAITING_CUSTOMER_VALIDATION";
      }).status;
    },
    isOrderFullyCalculatedAmounts: function isOrderFullyCalculatedAmounts() {
      return this.order.isFullyCalculatedAmounts;
    },
    isAdjusting: function isAdjusting() {
      return orderStatus.filter(function (x) {
        return ["ADJUSTING"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.order.status);
    },
    isEditingItemList: function isEditingItemList() {
      return this.idProductsUpdating.length > 0 || this.isAddingWine;
    },
    isAwaitingLogisticDetail: function isAwaitingLogisticDetail() {
      return this.mustRefreshLogisticDetails || !this.order.expedition_method && this.fetchingLogisticDetails.isPending;
    },
    isShippingInError: function isShippingInError() {
      return this.isShippingEditable && !this.isAwaitingLogisticDetail && (this.expedition_methods.length === 0 || this.expedition_methods.length === 1 && this.expedition_methods[0].isError);
    },
    departureCountry: function departureCountry() {
      var _this$order$expeditio, _this$expedition_meth;
      return ((_this$order$expeditio = this.order.expedition_methods[this.order.id_warehouse]) === null || _this$order$expeditio === void 0 ? void 0 : _this$order$expeditio.departureCountry) || ((_this$expedition_meth = this.expedition_methods[0]) === null || _this$expedition_meth === void 0 ? void 0 : _this$expedition_meth.departureCountry);
    },
    dialogAdjustmentData: function dialogAdjustmentData() {
      switch (this.dialogAdjustment.type) {
        case orderAdjustmentsTypes.USER_DECLINE.id:
          return {
            title: this.isOrderAwaitingCustomerValidation ? "Decline the order" : "Cancel the order",
            message_placeholder: "Please explain the reason for cancelling the order.",
            cta_label: "Decline order",
            success_toast_message: "Order has been declined and cancelled."
          };
        case orderAdjustmentsTypes.USER_ASK_ADJUSTMENT.id:
          return {
            title: "Ask for adjustments",
            message_placeholder: "Please explain your adjustments wishes",
            cta_label: "Send your request",
            success_toast_message: "Request has been sent."
          };
        case orderAdjustmentsTypes.USER_APPROVE.id:
          return {
            title: "Approve order",
            message_placeholder: "Please explain your approvement",
            cta_label: "Approve",
            success_toast_message: "Approvement has been sent."
          };
        case orderAdjustmentsTypes.ADMIN_DECLINE.id:
          return {
            title: "Cancel order",
            message_placeholder: "Please explain why you cancel this order to the customer. This message will be surrounded by standard message ; Before : Dear %CUSTOMER_NAME%, The order %ORDER_REFERENCE% has been cancelled. After : button 'View the order' Best regards.",
            cta_label: "Send to customer",
            success_toast_message: "Order cancelled."
          };
        case orderAdjustmentsTypes.ADMIN_PROPOSE_ADJUSTMENT.id:
          return {
            title: "Propose the adjustments",
            message_placeholder: "Please explain your adjustments to the customer. This message will be surrounded by standard message\nBefore : Dear %CUSTOMER_NAME%, We are suggesting a couple of adjustments for your order request %ORDER_REFERENCE%.\nAfter : You can choose to request for additional adjustments by following VIEW THE ORDER, or APPROVE or DECLINE the order without having to sign in. Best regards.",
            cta_label: "Send to customer",
            success_toast_message: "Proposition sent."
          };
        case "history":
          return {
            title: "History",
            message_placeholder: null,
            cta_label: null,
            success_toast_message: null
          };
        default:
          return null;
      }
    },
    nbBottles: function nbBottles() {
      var _this$order$items;
      return (_this$order$items = this.order.items) === null || _this$order$items === void 0 ? void 0 : _this$order$items.reduce(function (acc, item) {
        return acc + item.quantity;
      }, 0);
    },
    hasBeenPricePostedWithProperShippingFees: function hasBeenPricePostedWithProperShippingFees() {
      var _this$order$pricePost;
      return ((_this$order$pricePost = this.order.pricePostingUsaPro) === null || _this$order$pricePost === void 0 ? void 0 : _this$order$pricePost.id) > 0 && !this.order.shippingHasBeenCalculatedByMl;
    },
    uploadUrl: function uploadUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/uploader/order/").concat(this.order.id_order, "/files");
    },
    paymentState: function paymentState() {
      return _paymentState;
    },
    deliveryInstructionsEditable: function deliveryInstructionsEditable() {
      return !this.hasBeenValidated && !this.isCancelled;
    },
    isImporterPreventPayment: function isImporterPreventPayment() {
      var _this$order5, _this$order6;
      return +((_this$order5 = this.order) === null || _this$order5 === void 0 || (_this$order5 = _this$order5.importer) === null || _this$order5 === void 0 ? void 0 : _this$order5.id) > 0 && ((_this$order6 = this.order) === null || _this$order6 === void 0 || (_this$order6 = _this$order6.importer) === null || _this$order6 === void 0 ? void 0 : _this$order6.isPreventingPayment);
    },
    itemsRequiringTastingPhoto: function itemsRequiringTastingPhoto() {
      var _this$order$items$fil, _this$order7;
      return (_this$order$items$fil = (_this$order7 = this.order) === null || _this$order7 === void 0 ? void 0 : _this$order7.items.filter(function (x) {
        return x.wine.isTastingPhotoRequired;
      })) !== null && _this$order$items$fil !== void 0 ? _this$order$items$fil : [];
    },
    orderExpeditionMethodChosen: function orderExpeditionMethodChosen() {
      if (this.isAwaitingLogisticDetail) {
        var _this$lastExpeditionM, _this$lastExpeditionM2;
        return (_this$lastExpeditionM = (_this$lastExpeditionM2 = this.lastExpeditionMethod) === null || _this$lastExpeditionM2 === void 0 ? void 0 : _this$lastExpeditionM2.expedition_method) !== null && _this$lastExpeditionM !== void 0 ? _this$lastExpeditionM : 0;
      } else {
        return this.order.expedition_method;
      }
    },
    totalOfItemsIncludeDefaultShipping: function totalOfItemsIncludeDefaultShipping() {
      var _this$order8,
        _this3 = this;
      return (_this$order8 = this.order) === null || _this$order8 === void 0 || (_this$order8 = _this$order8.items) === null || _this$order8 === void 0 ? void 0 : _this$order8.reduce(function (acc, item) {
        return acc + _this3.getUnitPriceCurrencyForItem(item, _this3.orderExpeditionMethodChosen) * item.quantity;
      }, 0);
    }
  },
  methods: {
    toogleCollapseItemsList: function toogleCollapseItemsList() {
      this.isCollapsed = !this.isCollapsed;
      if (this.isCollapsed) {
        this.$nextTick(function () {
          document.querySelector("#order-summary-in").scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        });
      }
    },
    fetchOrder: function fetchOrder(_, ack) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this4$fetchingOrder$;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.fetchingOrder.isPending = true;
              (_this4$fetchingOrder$ = _this4.fetchingOrder.cancellationToken) === null || _this4$fetchingOrder$ === void 0 || _this4$fetchingOrder$.cancel();
              _this4.fetchingOrder.cancellationToken = axios.CancelToken.source();
              _this = _this4;
              _context2.next = 6;
              return request("/v1/order/" + _this4.order.id_order, "get", null, true, "api", null, _this4.fetchingOrder.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.fetchingOrder.isPending = false;
                  if (e.response.data) {
                    _this.$toasted.show(e.response.data.value, {
                      type: "warning"
                    });
                  }
                }
                throw e;
              });
            case 6:
              response = _context2.sent;
              _this4.order = _objectSpread(_objectSpread({}, _this4.order), response.data);
              _this4.computeCasings();
              ack(_this4.order);
              if (_this4.isOrderEditable) {
                _this4.fetchCompleteWinesForDiscounts();
              }
              _this4.fetchingOrder.isPending = false;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchItem: function fetchItem(itemId) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this5$fetchingItem$i, _this6, response, itemIndex, _this5$order$expediti, _this5$lastExpedition, newItem;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this5.fetchingItem[itemId]) {
                _this5.fetchingItem[itemId] = {
                  isPending: true
                };
              }
              _context3.prev = 1;
              (_this5$fetchingItem$i = _this5.fetchingItem[itemId].cancellationToken) === null || _this5$fetchingItem$i === void 0 || _this5$fetchingItem$i.cancel();
              _this5.fetchingItem[itemId].cancellationToken = axios.CancelToken.source();
              _this6 = _this5;
              _context3.next = 7;
              return request("/v1/orders/items/".concat(itemId), "get", null, true, "api", null, _this5.fetchingItem[itemId].cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this6.managedExceptions, "Unable to fetchItem");
                  _this6.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
                throw e;
              });
            case 7:
              response = _context3.sent;
              itemIndex = _this5.order.items.findIndex(function (x) {
                return x.id_item === itemId;
              });
              if (itemIndex > -1) {
                _this5.order.items[itemIndex] = _objectSpread({}, response.data.value);
              } else {
                newItem = _objectSpread({}, response.data.value);
                newItem.warehouseId = _this5.order.id_warehouse;
                newItem.warehouseName = _this5.order.warehouseName;
                newItem.expedition_method = (_this5$order$expediti = _this5.order.expedition_method) !== null && _this5$order$expediti !== void 0 ? _this5$order$expediti : (_this5$lastExpedition = _this5.lastExpeditionMethod) === null || _this5$lastExpedition === void 0 ? void 0 : _this5$lastExpedition.id;
                newItem.expeditionMethod = newItem.expedition_method;
                _this5.order.items.push(newItem);
              }
              _context3.next = 14;
              break;
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](1);
            case 14:
              _this5.computeCasings();
              delete _this5.fetchingItem[itemId];
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 12]]);
      }))();
    },
    cancelAddresses: function cancelAddresses() {
      this.isEditingAddresses = false;
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        delivery_address: this.bufferedAddresses.deliveryAddress
      });
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        billing_address: this.bufferedAddresses.billingAddress
      });
      this.sameAddress = this.bufferedAddresses.isSameAddress;
    },
    editAddresses: function editAddresses() {
      this.isEditingAddresses = true;
      this.bufferedAddresses = {
        deliveryAddress: _objectSpread({}, this.order.delivery_address),
        billingAddress: _objectSpread({}, this.order.billing_address),
        isSameAddress: this.sameAddress
      };
    },
    cancelBillingAddress: function cancelBillingAddress() {
      this.isEditingAddresses = false;
      this.mustRecalculateCharges = false;
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        billing_address: this.bufferedAddresses.billingAddress
      });
    },
    editBillingAddress: function editBillingAddress() {
      this.isEditingAddresses = true;
      this.bufferedAddresses = {
        billingAddress: _objectSpread({}, this.order.billing_address)
      };
    },
    computeCharges: function computeCharges(db) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var groupedShippingMethodsByDeparture, _this, shippingAmount, totalAmountCurrency;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this7.expedition_methods = _this7.getAvailableExpeditionMethods(db);
              _this7.expedition_methods = [].concat(_toConsumableArray(_this7.expedition_methods.filter(function (m) {
                return m.expedition_method !== 6;
              })), _toConsumableArray(_this7.expedition_methods.filter(function (m) {
                return m.expedition_method === 6;
              })));
              _context4.next = 4;
              return _this7.initShippingMethod();
            case 4:
              groupedShippingMethodsByDeparture = _this7.expedition_methods.reduce(function (acc, x) {
                if (!acc[x.departureWarehouseId]) return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, [x]));
                return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, [].concat(_toConsumableArray(acc[x.departureWarehouseId]), [x])));
              }, {}); // Compute order shipping amount
              _this = _this7;
              Object.values(groupedShippingMethodsByDeparture).forEach(function (x) {
                var _x = _slicedToArray(x, 1),
                  anyShippingMethod = _x[0];
                if (x.length === 1) {
                  _this.order.expedition_methods[anyShippingMethod.departureWarehouseId] = anyShippingMethod;
                }
                _this.order.items.filter(function (e) {
                  return anyShippingMethod.itemIds.includes(e.id_item);
                }).forEach(function (e) {
                  if (x.length === 1) e.expeditionMethod = anyShippingMethod.expedition_method;
                  if (!e.expeditionMethod) {
                    var itemWithExistingShippingMethod = _this.order.items.filter(function (it) {
                      return anyShippingMethod.itemIds.includes(it.id_item);
                    }).find(function (it) {
                      return !!it.expeditionMethod;
                    });
                    if (itemWithExistingShippingMethod) {
                      e.expeditionMethod = itemWithExistingShippingMethod.expeditionMethod;
                    }
                  }
                  if (!!e.expeditionMethod) {
                    var shippingMethod = x.find(function (s) {
                      return s.id === e.expeditionMethod;
                    });
                    if (shippingMethod) {
                      e.totalShipping = shippingMethod.price_numeric_currency;
                      e.shippingAmount = e.totalShipping / anyShippingMethod.itemIds.length;
                    }
                  }
                });
              });
              shippingAmount = _this7.order.items.reduce(function (acc, x) {
                return acc + x.shippingAmount || 0;
              }, 0);
              totalAmountCurrency = shippingAmount + _this7.order.items.reduce(function (acc, x) {
                return acc + x.unit_price_currency * x.quantity;
              }, 0);
              _this7.order = _objectSpread(_objectSpread({}, _this7.order), {}, {
                amount_shipping_currency: shippingAmount,
                total_amount_currency: totalAmountCurrency,
                total_amount_currency_include_credit_notes: totalAmountCurrency - _this7.order.credit_notes_amount_currency
              });
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    initShippingMethod: function initShippingMethod() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var initialShippingMethod, _this8$expedition_met, eta_min_hours, eta_max_hours, expedition_method, anyItem, shippingMethod;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              initialShippingMethod = _this8.order.expedition_method;
              if (!(_this8.expedition_methods.length === 1 && !_this8.expedition_methods[0].isErrorEvenSuperAdmin)) {
                _context5.next = 10;
                break;
              }
              _this8$expedition_met = _this8.expedition_methods[0], eta_min_hours = _this8$expedition_met.eta_min_hours, eta_max_hours = _this8$expedition_met.eta_max_hours, expedition_method = _this8$expedition_met.expedition_method;
              _this8.order.expedition_method = expedition_method;
              _this8.order.items.forEach(function (x) {
                return x.expeditionMethod = expedition_method;
              });
              _this8.order.eta_min_hours = eta_min_hours;
              _this8.order.eta_max_hours = eta_max_hours;
              if (!(_this8.order.expedition_method !== initialShippingMethod)) {
                _context5.next = 10;
                break;
              }
              _context5.next = 10;
              return _this8.updateExpeditionMethod();
            case 10:
              _this8.order.expedition_methods = _this8.expedition_methods.reduce(function (acc, x) {
                var item = _this8.order.items.find(function (e) {
                  return x.itemIds.includes(e.id_item);
                });
                if (item && item.expeditionMethod === x.expedition_method) {
                  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, x));
                }
                return acc;
              }, {});
              if (_this8.isShippingEditable) {
                anyItem = _this8.order.items[0];
                shippingMethod = _this8.expedition_methods.find(function (x) {
                  return anyItem.expeditionMethod === x.expedition_method;
                });
                if (!!shippingMethod) {
                  _this8.order.expedition_method = shippingMethod.expedition_method;
                  _this8.order.eta_min_hours = shippingMethod.eta_min_hours;
                  _this8.order.eta_max_hours = shippingMethod.eta_max_hours;
                } else {
                  _this8.order.expedition_method = null;
                }
              }
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getAvailableExpeditionMethods: function getAvailableExpeditionMethods(db) {
      var _this9 = this;
      return db.expedition_prices.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.expedition_price) >= 0) {
          var method_ref = Object.values(_this9.expeditionMethods).filter(function (ep) {
            return ep.id === x.expedition_method;
          })[0];
          var priceExp = x.expeditionPriceCurrency;
          return _objectSpread(_objectSpread({}, x), {}, {
            id: x.expedition_method,
            departureWarehouseId: x.departureWarehouseId,
            icon: method_ref.faIcon,
            label: method_ref.text,
            price_numeric_currency: priceExp,
            price_label: "+ ".concat(formatPrice(priceExp / x.itemIds.length), " ").concat(_this9.getSymbolCurrency(_this9.order.currency), " / bottle"),
            price_global_label: formatPrice(priceExp) + " " + _this9.getSymbolCurrency(_this9.order.currency),
            eta_label: _this9.getEtaLabel(x.eta_min_hours, x.eta_max_hours),
            original_object: x
          });
        }
      });
    },
    getEtaLabel: function getEtaLabel(eta_min_hours, eta_max_hours) {
      var unit = eta_min_hours > 72 || eta_max_hours && eta_max_hours > 72 ? "days" : "hours";
      if (unit === "days") {
        return Math.ceil(eta_min_hours / 24) + (eta_max_hours ? "-" + Math.ceil(eta_max_hours / 24) : "") + " " + unit;
      } else {
        return eta_min_hours + (eta_max_hours ? "-" + eta_max_hours : "") + " " + unit;
      }
    },
    fetchCompleteWinesForDiscounts: function fetchCompleteWinesForDiscounts() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this10$fetchingCompl, _this10$order;
        var wineIds, data, _this, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this10.fetchingCompleteWines.isPending = true;
              (_this10$fetchingCompl = _this10.fetchingCompleteWines.cancellationToken) === null || _this10$fetchingCompl === void 0 || _this10$fetchingCompl.cancel();
              _this10.fetchingCompleteWines.cancellationToken = axios.CancelToken.source();
              wineIds = _this10.order.items.map(function (x) {
                return +x.id_wine;
              });
              data = {
                id_wines: wineIds,
                calculatePrices: true,
                userIdTarget: +_this10.order.id_user,
                departureWarehouseIds: [_this10.order.id_warehouse],
                byPassPagingLimitation: true,
                bypassStockSeek: true,
                bypassDeletedCheck: true
              };
              if (((_this10$order = _this10.order) === null || _this10$order === void 0 || (_this10$order = _this10$order.pricePostingUsaPro) === null || _this10$order === void 0 ? void 0 : _this10$order.id) > 0) data.pricePostingUsaProId = _this10.order.pricePostingUsaPro.id;
              _this = _this10;
              _context6.next = 9;
              return request("/v1/wines/", "post", data, true, "api", null).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.fetchingCompleteWines.isPending = false;
                  _this.fetchingCompleteWines.cancellationToken = null;
                  var errorData = getErrorData(e, "Unable to fetch conditional discounts", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 9:
              response = _context6.sent;
              response.data.wines.forEach(function (completeWine) {
                var _this10$order2;
                var item = (_this10$order2 = _this10.order) === null || _this10$order2 === void 0 || (_this10$order2 = _this10$order2.items) === null || _this10$order2 === void 0 ? void 0 : _this10$order2.find(function (x) {
                  return x.id_wine === completeWine.id_wine;
                });
                if (item !== null) {
                  item.wine = _objectSpread(_objectSpread(_objectSpread({}, item.wine), completeWine), {}, {
                    casings: item.wine.casings
                  });
                }
              });
              _this10.fetchingCompleteWines.isPending = false;
              _this10.fetchingCompleteWines.cancellationToken = null;
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    updateDeliveryInstructions: function updateDeliveryInstructions() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this11$updateDeliver;
        var path, data;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              (_this11$updateDeliver = _this11.updateDeliveryInstructionsToken) === null || _this11$updateDeliver === void 0 || _this11$updateDeliver.cancel();
              _this11.updateDeliveryInstructionsToken = axios.CancelToken.source();
              path = "/v1/orders/" + _this11.order.id_order + "/delivery-instructions";
              data = {
                deliveryInstructions: _this11.newDeliveryInstructions,
                isSetAsDefaultForUserAddress: _this11.isDeliveryInstructionsAsDefaultForUserAdress
              };
              _context7.next = 6;
              return request(path, "put", data, true, "api", null, _this11.updateDeliveryInstructionsToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to update delivery instructions.", {
                    type: "error"
                  });
                  return;
                }
              });
            case 6:
              _this11.order.delivery_instructions = _this11.newDeliveryInstructions;
              _this11.editingDeliveryInstructions = false;
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    isOrderDeliveryInstructionsDefaultUser: function isOrderDeliveryInstructionsDefaultUser() {
      return String.isNullOrEmpty(this.order.delivery_instructions) && String.isNullOrEmpty(this.order.delivery_address.deliveryInstructions) || this.order.delivery_instructions === this.order.delivery_address.deliveryInstructions;
    },
    fetchOrderLogistic: function fetchOrderLogistic() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this12$fetchingLogis, _this12$lastExpeditio;
        var _this, response, _this12$expedition_me, rightExpedtionMethod;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this12.fetchingLogisticDetails.isPending = true;
              (_this12$fetchingLogis = _this12.fetchingLogisticDetails.cancellationToken) === null || _this12$fetchingLogis === void 0 || _this12$fetchingLogis.cancel();
              _this12.fetchingLogisticDetails.cancellationToken = axios.CancelToken.source();
              _this = _this12;
              _context8.next = 6;
              return request("/v1/order/".concat(_this12.order.id_order, "/logistic/"), "get", null, true, "api", null).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "An error occured. Please contact an administrator.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
              });
            case 6:
              response = _context8.sent;
              _this12.fetchingLogisticDetails.isPending = false;
              if (!response) {
                _context8.next = 11;
                break;
              }
              _context8.next = 11;
              return _this12.computeCharges(response.data);
            case 11:
              if (!(((_this12$lastExpeditio = _this12.lastExpeditionMethod) === null || _this12$lastExpeditio === void 0 ? void 0 : _this12$lastExpeditio.id) > 0)) {
                _context8.next = 16;
                break;
              }
              rightExpedtionMethod = (_this12$expedition_me = _this12.expedition_methods) === null || _this12$expedition_me === void 0 ? void 0 : _this12$expedition_me.find(function (x) {
                return x.id === _this12.lastExpeditionMethod.id;
              });
              if (!rightExpedtionMethod) {
                _context8.next = 16;
                break;
              }
              _context8.next = 16;
              return _this12.changeExpeditionMethod(rightExpedtionMethod);
            case 16:
              _this12.mustRefreshLogisticDetails = false;
              if (!_this12.order.isFullyCalculatedAmounts) {
                _this12.order = calculateOrderAmountsLocal(_this12.order);
              }
            case 18:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    updateExpeditionMethod: function updateExpeditionMethod() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this13$updatingExped, _this14;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!_this13.order.expedition_method) {
                _context9.next = 10;
                break;
              }
              _this13.updatingExpeditionMethod.isPending = true;
              (_this13$updatingExped = _this13.updatingExpeditionMethod.cancellationToken) === null || _this13$updatingExped === void 0 || _this13$updatingExped.cancel();
              _this13.updatingExpeditionMethod.cancellationToken = axios.CancelToken.source();
              _this14 = _this13;
              _context9.next = 7;
              return request("/v1/order/".concat(_this13.order.id_order, "/expedition-method"), "put", {
                expedition_method: _this13.order.expedition_method,
                eta_min_hours: _this13.order.eta_min_hours,
                eta_max_hours: _this13.order.eta_max_hours
              }, true, "api", null, _this13.updatingExpeditionMethod.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this14.updatingExpeditionMethod.isPending = false;
                  var errorData = getErrorData(e, _this14.managedExceptions, "Unable to change shipping type.");
                  _this14.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
                throw e;
              });
            case 7:
              _this13.lastExpeditionMethod = null;
              _this13.order = _objectSpread(_objectSpread({}, _this13.order), {}, {
                isFullyCalculatedAmounts: false,
                isFullyGeneratedDocuments: false
              });
              _this13.updatingExpeditionMethod.isPending = false;
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    changeExpeditionMethod: function changeExpeditionMethod(value) {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _lastExpeditionMethod, _lastExpeditionMethod2;
        var lastExpeditionMethods, _lastExpeditionMethod3, isDeselectingCellar, confirmed;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this15.resetMinimumsErrors();
              _this15.errorLabels.shipping = {};
              if (!_this15.order.expedition_methods) _this15.order.expedition_methods = {};
              _this15.order.expedition_method = value.id;
              _this15.order.eta_min_hours = value.eta_min_hours;
              _this15.order.eta_max_hours = value.eta_max_hours;
              lastExpeditionMethods = _objectSpread({}, _this15.order.expedition_methods);
              if (!((value.expedition_method === expeditionMethods.CELLAR_STORAGE.id || ((_lastExpeditionMethod = lastExpeditionMethods[value.departureWarehouseId]) === null || _lastExpeditionMethod === void 0 ? void 0 : _lastExpeditionMethod.id) === expeditionMethods.CELLAR_STORAGE.id) && value.expedition_method !== ((_lastExpeditionMethod2 = lastExpeditionMethods[value.departureWarehouseId]) === null || _lastExpeditionMethod2 === void 0 ? void 0 : _lastExpeditionMethod2.id))) {
                _context10.next = 27;
                break;
              }
              isDeselectingCellar = ((_lastExpeditionMethod3 = lastExpeditionMethods[value.departureWarehouseId]) === null || _lastExpeditionMethod3 === void 0 ? void 0 : _lastExpeditionMethod3.id) === expeditionMethods.CELLAR_STORAGE.id;
              _context10.next = 11;
              return _this15.$refs.confirm.open("To your attention", isDeselectingCellar ? "When deselecting this type of shipment, be aware that duties and taxes will be included in the products. Wine's prices will be update." : "When choosing the type of shipment « stored at the cellar », please be aware that duties and taxes will no longer be included on the products and may be charged to you later by the financial authorities. Product prices will be updated.", {
                color: "warning"
              });
            case 11:
              confirmed = _context10.sent;
              if (!confirmed) {
                _context10.next = 23;
                break;
              }
              _this15.order.expedition_methods[value.departureWarehouseId] = value;
              _this15.computeShippingAmount(value.id, value.price_numeric_currency);
              _context10.next = 17;
              return _this15.updateExpeditionMethod();
            case 17:
              _context10.next = 19;
              return _this15.calculateOrderAmounts();
            case 19:
              _context10.next = 21;
              return _this15.fetchOrder(null, function () {});
            case 21:
              _context10.next = 25;
              break;
            case 23:
              _this15.order = _objectSpread(_objectSpread({}, _this15.order), {}, {
                expedition_method: lastExpeditionMethods.id,
                eta_min_hours: lastExpeditionMethods.eta_min_hours,
                eta_max_hours: lastExpeditionMethods.eta_max_hours,
                expedition_methods: _objectSpread({}, lastExpeditionMethods)
              });
              return _context10.abrupt("return");
            case 25:
              _context10.next = 32;
              break;
            case 27:
              _this15.order.expedition_methods[value.departureWarehouseId] = value;
              _this15.computeShippingAmount(value.id, value.price_numeric_currency);
              _context10.next = 31;
              return _this15.updateExpeditionMethod();
            case 31:
              _this15.order = calculateOrderAmountsLocal(_this15.order);
            case 32:
              _this15.$nextTick(function () {
                _this15.order.expedition_methods = _objectSpread(_objectSpread({}, _this15.order.expedition_methods), {}, _defineProperty({}, value.departureWarehouseId, value));
              });
            case 33:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    computeShippingAmount: function computeShippingAmount(shippingMethod, totalShipping) {
      this.order.items.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          expeditionMethod: shippingMethod,
          totalShipping: totalShipping
        });
      });
      var shippingAmount = totalShipping;
      var totalAmountCurrency = shippingAmount + this.order.items.reduce(function (acc, x) {
        return acc + x.unit_price_currency * x.quantity;
      }, 0);
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        amount_shipping_currency: shippingAmount,
        total_amount_currency: totalAmountCurrency,
        total_amount_currency_include_credit_notes: totalAmountCurrency - this.order.credit_notes_amount_currency
      });
    },
    saveLastExpeditionMethod: function saveLastExpeditionMethod() {
      var _this16 = this;
      if (!!this.order.expedition_method) {
        this.lastExpeditionMethod = _objectSpread({}, this.expedition_methods.find(function (x) {
          return x.id === _this16.order.expedition_method;
        }));
      }
    },
    resetLogisticDetails: function resetLogisticDetails() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this17$resettingLogi, _this18;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this17.mustRefreshLogisticDetails = true;
              if (!_this17.order.expedition_method) {
                _context11.next = 16;
                break;
              }
              _this17.saveLastExpeditionMethod();
              _this17.order.expedition_method = 0;
              _this17.resettingLogisticDetails.isPending = true;
              (_this17$resettingLogi = _this17.resettingLogisticDetails.cancellationToken) === null || _this17$resettingLogi === void 0 || _this17$resettingLogi.cancel();
              _this17.resettingLogisticDetails.cancellationToken = axios.CancelToken.source();
              _this18 = _this17;
              _context11.next = 10;
              return request("/v1/orders/".concat(_this17.order.id_order, "/logistic-details/"), "delete", {
                doRecalculateOrderAmounts: false
              }, true, "api").catch(function (e) {
                _this18.mustRefreshLogisticDetails = false;
                _this18.order.expedition_method = _this18.lastExpeditionMethod.id;
                _this18.resettingLogisticDetails.isPending = false;
                var errorData = getErrorData(e, _this18.managedExceptions, "An error occured. Please contact an administrator.");
                _this18.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 10:
              _this17.order.expedition_methods = [];
              _this17.order.eta_min_hours = 0;
              _this17.order.eta_max_hours = null;
              _this17.order.amount_shipping_currency = null;
              _this17.order.items = _this18.order.items.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  expeditionMethod: null
                });
              });
              _this17.resettingLogisticDetails.isPending = false;
            case 16:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    fetchAdjustments: function fetchAdjustments() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var response;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return request("/v1/orders/" + _this19.order.id_order + "/adjustments", "get", null, true, "api").catch(function (_) {
                _this19.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              });
            case 2:
              response = _context12.sent;
              _this19.adjustments = response.data;
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    saveAddress: function saveAddress() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this20$updateAddress;
        var _this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              (_this20$updateAddress = _this20.updateAddressesToken) === null || _this20$updateAddress === void 0 || _this20$updateAddress.cancel();
              _this20.updateAddressesToken = axios.CancelToken.source();
              _this = _this20;
              _context13.next = 5;
              return request("/v1/order/".concat(_this20.order.id_order, "/addresses"), "put", {
                deliveryAddress: _this.order.delivery_address,
                billingAddress: _this.order.billing_address
              }, true, "api", null, _this20.updateAddressesToken).then(function (_) {
                _this.isEditingAddresses = false;
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to update addresses.", {
                    type: "error"
                  });
                  return;
                }
              });
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    addressChange: function addressChange() {
      if (this.sameAddress) {
        this.order.billing_address = _objectSpread({}, this.order.delivery_address);
      }
    },
    refetchDocs: function refetchDocs() {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this21$fetchingDocum, _this22, response;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!_this21.isDocumentsConsultable) {
                _context14.next = 16;
                break;
              }
              _this21.fetchingDocuments.isPending = true;
              if (_this21.order.isFullyCalculatedAmounts) {
                _context14.next = 5;
                break;
              }
              _context14.next = 5;
              return _this21.calculateAndFetchOrder();
            case 5:
              (_this21$fetchingDocum = _this21.fetchingDocuments.cancellationToken) === null || _this21$fetchingDocum === void 0 || _this21$fetchingDocum.cancel();
              _this21.fetchingDocuments.cancellationToken = axios.CancelToken.source();
              _this22 = _this21;
              _context14.next = 10;
              return request("/v1/orders/" + _this22.order.id_order + "/docs", "get", null, true, "api", null, _this21.fetchingDocuments.cancellationToken);
            case 10:
              response = _context14.sent;
              _this21.documents = response.data.filter(function (x) {
                var _x$document_urls;
                return ((_x$document_urls = x.document_urls) === null || _x$document_urls === void 0 ? void 0 : _x$document_urls.length) > 0;
              }).reduce(function (acc, x) {
                return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, x), {}, {
                  children: _toConsumableArray(x.document_urls)
                })]);
              }, []);
              _this21.isDocumentsFetched = true;
              _this21.fetchingDocuments.isPending = false;
              _context14.next = 17;
              break;
            case 16:
              _this21.fetchingDocuments.isPending = false;
            case 17:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    openDocument: function openDocument(item) {
      window.open(item.url, "_blank");
    },
    calculateAndFetchOrder: function calculateAndFetchOrder() {
      var _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return _this23.calculateOrderAmounts();
            case 3:
              _context15.next = 5;
              return _this23.fetchOrder(null, function () {});
            case 5:
              _context15.next = 9;
              break;
            case 7:
              _context15.prev = 7;
              _context15.t0 = _context15["catch"](0);
            case 9:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[0, 7]]);
      }))();
    },
    dialogAdjustmentAction: function dialogAdjustmentAction() {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this, _this24$proposingAdju, path, data, errorData;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this24.errorLabels.adjustment = "";
              if (!(_this24.dialogAdjustment.type == orderAdjustmentsTypes.USER_ASK_ADJUSTMENT.id)) {
                _context16.next = 5;
                break;
              }
              if (!(!_this24.dialogAdjustment.message || _this24.dialogAdjustment.message.length < 1)) {
                _context16.next = 5;
                break;
              }
              _this24.errorLabels.adjustment = _this24.errorMessages.mandatory;
              return _context16.abrupt("return");
            case 5:
              _this24.proposingAdjustment.isPending = true;
              _this = _this24;
              _context16.prev = 7;
              (_this24$proposingAdju = _this24.proposingAdjustment.cancellationToken) === null || _this24$proposingAdju === void 0 || _this24$proposingAdju.cancel();
              _this24.proposingAdjustment.cancellationToken = axios.CancelToken.source();
              path = "/v1/orders/adjustments";
              data = {
                order_id: _this24.order.id_order,
                type: _this24.dialogAdjustment.type,
                custom_message: _this24.dialogAdjustment.message
              };
              _context16.next = 14;
              return request(path, "post", data, true, "api", null, _this24.proposingAdjustment.cancellationToken);
            case 14:
              _context16.next = 16;
              return _this24.fetchOrder(null, function () {});
            case 16:
              _context16.next = 18;
              return _this24.fetchAdjustments();
            case 18:
              _this24.dialogAdjustment.message = "";
              _this24.dialogAdjustment.visible = false;
              _this24.$toasted.show(_this24.dialogAdjustmentData.success_toast_message, {
                type: "success"
              });
              _context16.next = 26;
              break;
            case 23:
              _context16.prev = 23;
              _context16.t0 = _context16["catch"](7);
              if (!axios.isCancel(_context16.t0)) {
                errorData = getErrorData(_context16.t0, _this.managedExceptions, "Unable to cancel order", true);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              }
            case 26:
              _this24.proposingAdjustment.isPending = false;
            case 27:
            case "end":
              return _context16.stop();
          }
        }, _callee16, null, [[7, 23]]);
      }))();
    },
    returnToAdjustableStatus: function returnToAdjustableStatus() {
      var _this25 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (_this25.order.isFullyCalculatedAmounts) {
                _context17.next = 3;
                break;
              }
              _context17.next = 3;
              return _this25.calculateOrderAmounts();
            case 3:
              _context17.next = 5;
              return _this25.$refs.confirm.open("To your attention", "Are you sure you want to make adjustments on this order ?", {
                color: "green"
              });
            case 5:
              confirmed = _context17.sent;
              if (confirmed) {
                _this25.returnToAdjustingStatus();
              }
            case 7:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    returnToAdjustingStatus: function returnToAdjustingStatus() {
      var _this26 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this26$returningToAd;
        var statusInt, data, _this;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this26.returningToAdjusting.isPending = true;
              (_this26$returningToAd = _this26.returningToAdjusting.cancellationToken) === null || _this26$returningToAd === void 0 || _this26$returningToAd.cancel();
              _this26.returningToAdjusting.cancellationToken = axios.CancelToken.source();
              statusInt = orderStatus.find(function (x) {
                return x.id === "ADJUSTING";
              }).status;
              data = {
                send_mails: false
              };
              _this = _this26;
              _context18.next = 8;
              return request("/v1/order/" + _this.order.id_order + "/state/" + statusInt, "put", data, true, "api", null, _this.returningToAdjusting.cancellationToken).catch(function (e) {
                _this.returningToAdjusting.isPending = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to return in adjusting status.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 8:
              _context18.prev = 8;
              _context18.next = 11;
              return _this26.fetchOrder(null, function () {});
            case 11:
              if (_this26.isShippingEditable && (!_this26.expedition_methods || _this26.expedition_methods.length === 0)) {
                _this26.fetchOrderLogistic();
              }
              _this26.$toasted.show("Order status updated.", {
                type: "success"
              });
              _context18.next = 17;
              break;
            case 15:
              _context18.prev = 15;
              _context18.t0 = _context18["catch"](8);
            case 17:
              _this26.returningToAdjusting.isPending = false;
            case 18:
            case "end":
              return _context18.stop();
          }
        }, _callee18, null, [[8, 15]]);
      }))();
    },
    confirmAdjustments: function confirmAdjustments() {
      var _this27 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var _this27$confirmingAdj, statusInt, data, _this28;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (!_this27.checkInputsPayment()) {
                _context19.next = 16;
                break;
              }
              if (_this27.order.isFullyCalculatedAmounts) {
                _context19.next = 4;
                break;
              }
              _context19.next = 4;
              return _this27.calculateOrderAmounts();
            case 4:
              _this27.confirmingAdjustments.isPending = true;
              (_this27$confirmingAdj = _this27.confirmingAdjustments.cancellationToken) === null || _this27$confirmingAdj === void 0 || _this27$confirmingAdj.cancel();
              _this27.confirmingAdjustments.cancellationToken = axios.CancelToken.source();
              statusInt = orderStatus.find(function (x) {
                return x.id === "AWAITING_VALIDATION";
              }).status;
              data = {
                send_mails: false
              };
              _this28 = _this27;
              _context19.next = 12;
              return request("/v1/order/" + _this28.order.id_order + "/state/" + statusInt, "put", data, true, "api", null, _this28.confirmingAdjustments.cancellationToken).catch(function (e) {
                _this28.confirmingAdjustments.isPending = false;
                var errorData = getErrorData(e, _this28.managedExceptions, "Unable to confirm adjustments.");
                _this28.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 12:
              _context19.next = 14;
              return _this27.fetchOrder(null, function () {});
            case 14:
              _this27.$toasted.show("Order status updated.", {
                type: "success"
              });
              _this27.confirmingAdjustments.isPending = false;
            case 16:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    adminConfirmOrderForCustomer: function adminConfirmOrderForCustomer() {
      var _this29 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var _this29$itemsRequirin;
        var valid, itemIdsRequiringTastingPhoto, _this29$confirmingFor, statusInt, data, _this30;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              valid = true;
              if (!_this29.checkboxCGV || !_this29.checkboxLawCompliance) {
                _this29.errorLabels.cgv = _this29.errorMessages.cgv.required;
                valid = false;
              }
              if (_this29.order.buyer_term == null) {
                _this29.errorLabels.terms = _this29.errorMessages.mandatory;
                valid = false;
              }
              if (((_this29$itemsRequirin = _this29.itemsRequiringTastingPhoto) === null || _this29$itemsRequirin === void 0 ? void 0 : _this29$itemsRequirin.length) > 0) {
                itemIdsRequiringTastingPhoto = _this29.itemsRequiringTastingPhoto.map(function (x) {
                  return x.id_item;
                });
                if (itemIdsRequiringTastingPhoto.some(function (id) {
                  return !_this29.checkboxTastingPhoto[id];
                })) {
                  _this29.errorLabels.tastingPhoto = _this29.errorMessages.tastingPhoto.required;
                  valid = false;
                }
              }
              if (!_this29.isStoredInbound && !_this29.$refs.deliveryAddress.validateForm()) {
                valid = false;
              }
              if (!_this29.sameAddress && !_this29.$refs.billingAddress.validateForm()) {
                valid = false;
              }
              if (!valid) {
                _context20.next = 22;
                break;
              }
              if (_this29.order.isFullyCalculatedAmounts) {
                _context20.next = 10;
                break;
              }
              _context20.next = 10;
              return _this29.calculateOrderAmounts();
            case 10:
              _this29.confirmingForCustomer.isPending = true;
              (_this29$confirmingFor = _this29.confirmingForCustomer.cancellationToken) === null || _this29$confirmingFor === void 0 || _this29$confirmingFor.cancel();
              _this29.confirmingForCustomer.cancellationToken = axios.CancelToken.source();
              statusInt = orderStatus.find(function (x) {
                return x.id === "AWAITING_VALIDATION";
              }).status;
              data = {};
              _this30 = _this29;
              _context20.next = 18;
              return request("/v1/order/" + _this30.order.id_order + "/state/" + statusInt, "put", data, true, "api", null, _this30.confirmingForCustomer.cancellationToken).catch(function (e) {
                _this30.confirmingForCustomer.isPending = false;
                var errorData = getErrorData(e, _this30.managedExceptions, "Unable to confirm for customer.");
                _this30.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 18:
              _context20.next = 20;
              return _this29.fetchOrder(null, function () {});
            case 20:
              _this29.$toasted.show("Order status updated.", {
                type: "success"
              });
              _this29.confirmingForCustomer.isPending = false;
            case 22:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    calculateOrderAmounts: function calculateOrderAmounts() {
      var _this31 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var _this31$calculatingOr;
        var _this;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _this31.calculatingOrderAmounts.isPending = true;
              (_this31$calculatingOr = _this31.calculatingOrderAmounts.cancellationToken) === null || _this31$calculatingOr === void 0 || _this31$calculatingOr.cancel();
              _this31.calculatingOrderAmounts.cancellationToken = axios.CancelToken.source();
              _this = _this31;
              _context21.next = 6;
              return request("/v1/order/".concat(_this31.order.id_order, "/calculate-amounts"), "put", null, true, "api", null, _this31.calculatingOrderAmounts.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.order.isFullyCalculatedAmounts = false;
                  _this.calculatingOrderAmounts.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to calculate amounts.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 6:
              _this31.calculatingOrderAmounts.isPending = false;
            case 7:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }))();
    },
    changeQuantityOrder: function changeQuantityOrder(item, quantity) {
      var _this32 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var casing, itemRef, itemId, casingId, _this32$changingQuant, _this33;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _this32.resetMinimumsErrors();
              casing = item.casingId.match(/\d+/)[0];
              quantity = quantity * casing;
              itemRef = _this32.order.items.find(function (x) {
                return x.id_item === item.id_item;
              });
              itemRef.quantity = quantity;
              itemRef.casingId = item.casingId;
              itemRef.total_amount = item.quantity * item.unit_price;
              if (!(itemRef.quantity == 0)) {
                _context22.next = 11;
                break;
              }
              _this32.confirmDeleteItem(item.id_item);
              _context22.next = 33;
              break;
            case 11:
              _this32.addItemUpdating(item.id_item);
              itemId = item.id_item;
              casingId = item.casingId;
              if (!_this32.changingQuantityOrder[itemId]) {
                _this32.changingQuantityOrder[itemId] = {
                  isPending: true
                };
              }
              _context22.prev = 15;
              (_this32$changingQuant = _this32.changingQuantityOrder[itemId].cancellationToken) === null || _this32$changingQuant === void 0 || _this32$changingQuant.cancel();
              _this32.changingQuantityOrder[itemId].cancellationToken = axios.CancelToken.source();
              _this33 = _this32;
              _context22.next = 21;
              return request("/v1/basket/items/".concat(itemId, "/quantity"), "post", {
                orderId: _this32.order.id_order,
                quantity: quantity,
                casingId: casingId
              }, true, "api", null, _this32.changingQuantityOrder[itemId].cancellationToken).catch(function (e) {
                var _e$response, _e$response2;
                if (e !== null && e !== void 0 && (_e$response = e.response) !== null && _e$response !== void 0 && (_e$response = _e$response.data) !== null && _e$response !== void 0 && (_e$response = _e$response.value) !== null && _e$response !== void 0 && _e$response.message) {
                  var message = e.response.data.value.message;
                  _this33.$toasted.show(message, {
                    type: "warning"
                  });
                } else if (e !== null && e !== void 0 && (_e$response2 = e.response) !== null && _e$response2 !== void 0 && (_e$response2 = _e$response2.data) !== null && _e$response2 !== void 0 && (_e$response2 = _e$response2.value) !== null && _e$response2 !== void 0 && _e$response2.errorMessage) {
                  var errorMessage = e.response.data.value.errorMessage;
                  _this33.$toasted.show(errorMessage, {
                    type: "warning"
                  });
                } else {
                  _this33.$toasted.show("An error occurred. Please contact an administrator.", {
                    type: "error"
                  });
                }
                var itemEc = _this33.order.items.find(function (x) {
                  return x.id_item === itemId;
                });
                itemEc.quantity = item.original_qty;
                delete _this33.changingQuantityOrder[itemId];
                throw e;
              });
            case 21:
              _this32.order = _objectSpread(_objectSpread({}, _this32.order), {}, {
                isFullyCalculatedAmounts: false,
                isFullyGeneratedDocuments: false
              });
              _context22.next = 24;
              return _this32.resetLogisticDetails();
            case 24:
              _context22.next = 28;
              break;
            case 26:
              _context22.prev = 26;
              _context22.t0 = _context22["catch"](15);
            case 28:
              _context22.next = 30;
              return _this32.fetchItem(itemId);
            case 30:
              _this32.order = calculateOrderAmountsLocal(_this32.order);
              _this32.removeItemUpdating(itemId);
              delete _this32.changingQuantityOrder[itemId];
            case 33:
            case "end":
              return _context22.stop();
          }
        }, _callee22, null, [[15, 26]]);
      }))();
    },
    addItemUpdating: function addItemUpdating(id_item) {
      this.idProductsUpdating.push(id_item);
    },
    removeItemUpdating: function removeItemUpdating(id_item) {
      this.idProductsUpdating.splice(this.idProductsUpdating.indexOf(id_item), 1);
    },
    isActiveItem: function isActiveItem(item) {
      var _item$wine, _item$wine2, _item$wine3;
      return !(item !== null && item !== void 0 && item.hasClosedStock) && (item === null || item === void 0 || (_item$wine = item.wine) === null || _item$wine === void 0 ? void 0 : _item$wine.is_active) && !(item !== null && item !== void 0 && (_item$wine2 = item.wine) !== null && _item$wine2 !== void 0 && _item$wine2.deleted) && !(item !== null && item !== void 0 && (_item$wine3 = item.wine) !== null && _item$wine3 !== void 0 && _item$wine3.isClosedStock);
    },
    searchWinesAddables: function searchWinesAddables(value) {
      var _this34 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var search, _this34$addingWine$se, _this34$order$id_ware, departureWarehouseId, data, _this35, response, idWinesInOrder;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              if (isArrowKey(value.keyCode)) {
                _context23.next = 20;
                break;
              }
              search = value.target.value;
              _this34.addingWine.searchingWines.searchValue = value.target.value;
              if (!(search.length < 3)) {
                _context23.next = 7;
                break;
              }
              _this34.addingWine.searchingWines.results = [];
              _context23.next = 20;
              break;
            case 7:
              _this34.addingWine.searchingWines.isPending = true;
              (_this34$addingWine$se = _this34.addingWine.searchingWines.cancellationToken) === null || _this34$addingWine$se === void 0 || _this34$addingWine$se.cancel();
              _this34.addingWine.searchingWines.cancellationToken = axios.CancelToken.source();
              departureWarehouseId = (_this34$order$id_ware = _this34.order.id_warehouse) !== null && _this34$order$id_ware !== void 0 ? _this34$order$id_ware : Object.keys(_this34.order.expedition_methods)[0];
              data = {
                filters: {
                  StockOnly: true
                },
                label: search,
                departureWarehouseIds: [departureWarehouseId],
                calculate_prices: false,
                userIdTarget: _this34.order.id_user,
                byPassStockReservation: false
              };
              _this35 = _this34;
              _context23.next = 15;
              return request("/v1/wines", "post", data, true, "api", null, _this34.addingWine.searchingWines.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this35.addingWine.searchingWines.isPending = false;
                  var errorData = getErrorData(e, _this35.managedExceptions, "Unable to get availables wines");
                  handleErrorData(_this35, errorData);
                }
                throw e;
              });
            case 15:
              response = _context23.sent;
              idWinesInOrder = _this35.order.items.map(function (y) {
                return y.id_wine;
              });
              _this34.addingWine.searchingWines.results = response.data.wines.filter(function (x) {
                return !idWinesInOrder.includes(x.id_wine);
              });
              if (_this34.addingWine.searchingWines.results.length > 0) {
                _this34.addingWine.searchingWines.results.map(function (x) {
                  var defaultCasingId = x.casings.find(function (x) {
                    return x.isDefault;
                  }).casingId;
                  x.display_name = x.display_name + " (" + defaultCasingId + ") " + " - " + x.sku;
                  x.casings = _this35.casingsAvailable({
                    wine: x,
                    casingId: defaultCasingId
                  });
                  return x;
                });
              } else {
                _this35.$refs[ERROR_DATA.ref].open(ERROR_DATA.DIALOG_TYPES.DIALOG_WARNING.id, "No product available, or already in this order.", {
                  showMessage: true,
                  showTitle: true
                }, "Please take note");
              }
              _this34.addingWine.searchingWines.isPending = false;
            case 20:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }))();
    },
    addWine: function addWine(wine) {
      var _this36 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var _this36$addingWine$ca, _wine$stocks$;
        var quantity, casingId, data, _this, response;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _this36.addingWine.isPending = true;
              (_this36$addingWine$ca = _this36.addingWine.cancellationToken) === null || _this36$addingWine$ca === void 0 || _this36$addingWine$ca.cancel();
              _this36.addingWine.cancellationToken = axios.CancelToken.source();
              quantity = 1;
              casingId = "OC1";
              if (wine.casings.some(function (wc) {
                return wc.isDefault && wc.quantity <= wine.stock_quantity;
              })) {
                casingId = wine.casings.find(function (wc) {
                  return wc.isDefault;
                }).casingId;
              } else if (wine.casings.some(function (wc) {
                return wc.quantity == 1;
              })) {
                casingId = wine.casings.find(function (wc) {
                  return wc.quantity == 1;
                }).casingId;
              }
              data = {
                id_order: _this36.order.id_order,
                expeditionMethod: _this36.order.expedition_method,
                id_wine: wine.id_wine,
                id_stock: wine.id_stock > 0 ? wine.id_stock : (_wine$stocks$ = wine.stocks[0]) === null || _wine$stocks$ === void 0 ? void 0 : _wine$stocks$.id_stock,
                quantity: quantity * casingId.match(/\d+/)[0],
                casingId: casingId
              };
              _this = _this36;
              _context24.next = 10;
              return request("/v1/basket/items", "post", data, true, "api", null, _this36.addingWine.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.addingWine.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions);
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
                throw e;
              });
            case 10:
              response = _context24.sent;
              _this36.order = _objectSpread(_objectSpread({}, _this36.order), {}, {
                isFullyCalculatedAmounts: false,
                isFullyGeneratedDocuments: false
              });
              _context24.next = 14;
              return _this36.fetchItem(response.data);
            case 14:
              _context24.next = 16;
              return _this36.resetLogisticDetails();
            case 16:
              _this36.order = calculateOrderAmountsLocal(_this36.order);
              _this36.addingWine.isPending = false;
              _this36.addingWine.itemChosen = null;
              _this36.addingWine.searchingWines.results = [];
              _this36.resetMinimumsErrors();
              _this36.$toasted.show("Product added to the order", {
                type: "success"
              });
            case 22:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }))();
    },
    confirmDeleteItem: function confirmDeleteItem(itemId) {
      var _this37 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              if (!(_this37.order.items.length < 2)) {
                _context25.next = 4;
                break;
              }
              _this37.$toasted.show("You can't remove the last item. You should cancel the order", {
                type: "warning"
              });
              _context25.next = 8;
              break;
            case 4:
              _context25.next = 6;
              return _this37.$refs.confirm.open("Delete", "Are you sure you want to delete this product ?", {
                color: "red"
              });
            case 6:
              confirmed = _context25.sent;
              if (confirmed) _this37.deleteItem(itemId);
            case 8:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    deleteItem: function deleteItem(itemId) {
      var _this38 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var backupOrder, _this38$deletingItem$, item, _this39;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _this38.addItemUpdating(itemId);
              backupOrder = _objectSpread({}, _this38.order);
              backupOrder = _objectSpread(_objectSpread({}, backupOrder), {}, {
                items: _toConsumableArray(backupOrder.items)
              });
              if (!_this38.deletingItem[itemId]) {
                _this38.deletingItem[itemId] = {
                  isPending: true
                };
              }
              _context26.prev = 4;
              item = _this38.order.items.find(function (x) {
                return x.id_item === itemId;
              });
              (_this38$deletingItem$ = _this38.deletingItem[itemId].cancellationToken) === null || _this38$deletingItem$ === void 0 || _this38$deletingItem$.cancel();
              _this38.deletingItem[itemId].cancellationToken = axios.CancelToken.source();
              _this39 = _this38;
              _context26.next = 11;
              return request("/v1/basket/items/".concat(itemId), "delete", {
                orderId: _this38.order.id_order
              }, true, "api", null, _this38.deletingItem[itemId].cancellationToken).catch(function (e) {
                _this39.order = backupOrder;
                var errorData = getErrorData(e, _this39.managedExceptions, "Unable to remove item", true);
                handleErrorData(_this39, errorData);
                throw e;
              });
            case 11:
              _this38.order.items.splice(_this38.order.items.indexOf(item), 1);
              _this38.order = _objectSpread(_objectSpread({}, _this38.order), {}, {
                isFullyCalculatedAmounts: false,
                isFullyGeneratedDocuments: false
              });
              _this38.$toasted.show("Product removed.", {
                type: "success"
              });
              _context26.next = 16;
              return _this38.resetLogisticDetails();
            case 16:
              _this38.order = calculateOrderAmountsLocal(_this38.order);
              _context26.next = 21;
              break;
            case 19:
              _context26.prev = 19;
              _context26.t0 = _context26["catch"](4);
            case 21:
              delete _this38.deletingItem[itemId];
              _this38.removeItemUpdating(itemId);
            case 23:
            case "end":
              return _context26.stop();
          }
        }, _callee26, null, [[4, 19]]);
      }))();
    },
    computeCasings: function computeCasings() {
      var _this40 = this;
      this.order.items.map(function (x) {
        return x.wine.casings = _this40.casingsAvailable(x);
      });
    },
    casingsAvailable: function casingsAvailable(item) {
      var wineCasings = item.wine.casings.map(function (wc) {
        return _objectSpread(_objectSpread({}, wc), {}, {
          textCard: casingWines.find(function (x) {
            return x.value == wc.casingId;
          }).textCard
        });
      });
      if (!wineCasings.some(function (x) {
        return x.casingId === item.casingId;
      })) {
        var adminCasingToAdd = casingWines.find(function (x) {
          return x.value === item.casingId;
        });
        adminCasingToAdd.casingId = adminCasingToAdd.value;
        wineCasings.push(adminCasingToAdd);
      }
      wineCasings.sort(function (a, b) {
        return a.quantity - b.quantity;
      });
      return wineCasings;
    },
    checkInputsPayment: function checkInputsPayment() {
      this.resetMinimumsErrors();
      var amountCurrencyByPassVolume = this.$whitelabel.orderLimitMinPriceWithoutShipping * this.order.currencyRate;
      var totalVolumeMl = this.order.items.reduce(function (acc, i) {
        return acc + i.quantity * i.wine.bottling;
      }, 0);
      var totalAmountCurrency = this.order.items.reduce(function (acc, i) {
        return acc + i.total_amount_currency - ((i === null || i === void 0 ? void 0 : i.totalShipping) || 0);
      }, 0);
      var invalidOrder = totalVolumeMl < this.$whitelabel.orderLimitMinVolume && totalAmountCurrency < amountCurrencyByPassVolume;
      if (invalidOrder) {
        this.errorLabels.quantity_orders = {
          anchor: "in",
          text: "Minimum order quantity of " + parseInt(this.$whitelabel.orderLimitMinVolume / 750) + " bottles (" + this.$whitelabel.orderLimitMinVolume / 1000 + "L) or " + this.formatPrice(amountCurrencyByPassVolume) + " " + this.getSymbolCurrency(this.order.currency) + " of total value"
        };
      }
      return !invalidOrder;
    },
    startEditDeliveryInstructions: function startEditDeliveryInstructions() {
      var _this41 = this;
      this.editingDeliveryInstructions = true;
      this.newDeliveryInstructions = this.order.delivery_instructions;
      this.$nextTick(function (_) {
        _this41.$refs.inputDeliveryInstruction.focus();
      });
    },
    resetMinimumsErrors: function resetMinimumsErrors() {
      this.errorLabels.quantity_orders = "";
    },
    getRequiredTastingPhotos: function getRequiredTastingPhotos() {
      var _this42 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var _this42$order;
        var _this42$order2, _this43, formSearch, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              if (!(_this42.tastingPhotos.canManage && _this42.isDelivered && (_this42$order = _this42.order) !== null && _this42$order !== void 0 && _this42$order.hasTastingPhotoRequired)) {
                _context27.next = 11;
                break;
              }
              _this42.tastingPhotos.required.isSearchPending = true;
              _this42.tastingPhotos.required.items = [];
              _this43 = _this42;
              formSearch = {
                orderIds: [(_this42$order2 = _this42.order) === null || _this42$order2 === void 0 ? void 0 : _this42$order2.id_order],
                allowedStatus: [TASTING_PHOTOS.REQUIRED.STATUS.TO_TAKE.id, TASTING_PHOTOS.REQUIRED.STATUS.PARTIALLY_TAKEN.id]
              };
              paramsQuery = Object.encodeToUri(formSearch);
              _context27.next = 8;
              return request("/v1/tasting-photos/required?params=".concat(paramsQuery), "get", null, true, "api").catch(function (e) {
                _this43.tastingPhotos.required.isSearchPending = false;
                _this43.$toasted.show("Unable to load required photos.", {
                  type: "error"
                });
                throw e;
              });
            case 8:
              response = _context27.sent;
              _this42.tastingPhotos.required.items = _toConsumableArray(response.data.value);
              _this42.tastingPhotos.required.isSearchPending = false;
            case 11:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }))();
    },
    openTastingPhotoUploader: function openTastingPhotoUploader(tastingPhotoRequiredId) {
      var _this44 = this;
      this.tastingPhotos.upload.tastingPhotoRequiredId = tastingPhotoRequiredId;
      this.tastingPhotos.upload.isComponentCreated = true;
      this.$nextTick(function () {
        _this44.$refs.tastingPhotoUploadForm.open();
      });
    },
    closeTastingPhotoUploader: function closeTastingPhotoUploader() {
      var _this45 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _this45.tastingPhotos.upload.isComponentCreated = false;
              _this45.getRequiredTastingPhotos();
            case 2:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }))();
    },
    isShippingOutOfRange: function isShippingOutOfRange() {
      var _this$expedition_meth2;
      return ((_this$expedition_meth2 = this.expedition_methods) === null || _this$expedition_meth2 === void 0 ? void 0 : _this$expedition_meth2.length) === 1 && this.expedition_methods[0].isOutOfRange;
    },
    getShippingOutOfRangeMessage: function getShippingOutOfRangeMessage() {
      var nbVariation = this.expedition_methods[0].outOfRangeVariation;
      if (nbVariation > 0) {
        return "You should add ".concat(nbVariation, " regular bottle").concat(nbVariation > 1 && "s", " to get an available shipping method");
      } else {
        return "You should remove ".concat(nbVariation, " regular bottle").concat(nbVariation > 1 && "s", " to get an available shipping method");
      }
    },
    isShippingInErrorEvenSuperAdmin: function isShippingInErrorEvenSuperAdmin() {
      var _this$expedition_meth3;
      return ((_this$expedition_meth3 = this.expedition_methods) === null || _this$expedition_meth3 === void 0 ? void 0 : _this$expedition_meth3.length) === 1 && this.expedition_methods[0].isErrorEvenSuperAdmin;
    },
    openToS: function openToS() {
      var anchor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var routeData = this.$router.resolve({
        name: "userTermsOfSales",
        hash: anchor
      });
      window.open(routeData.href);
    },
    productDetails: function productDetails(wine) {
      var detailsRoute = wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "adminSpiritsDetails" : "adminWineDetails";
      return {
        name: detailsRoute,
        params: {
          id: wine.id_wine
        }
      };
    },
    isHolding: isHolding,
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice,
    getFullNameUserHtml: getFullNameUserHtml,
    getFullNameUser: getFullNameUser,
    scrollTo: scrollTo,
    filterIntegerKey: filterIntegerKey,
    getOrderConfirmationReference: getOrderConfirmationReference,
    getUnitPriceCurrencyForItem: getUnitPriceCurrencyForItem,
    showShippingPriceMinusDefault: showShippingPriceMinusDefault
  }
};